<script>
import Component from '~/sites/oknanebodvere/pages/index'
export default {
  extends: Component,
}
</script>
